import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  loginButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '5.5rem',
    height: '2.2rem',
    borderRadius: '30px',
    background: theme.palette.primary.contrastText,
    color: theme.palette.text.secondary,
    '&:hover': {
      background: theme.palette.primary.dark
    },
    [theme.breakpoints.only('xl')]: {
      width: '6.5rem',
      height: '2.8rem'
    }
  },
  loginButtonActive: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '120px',
    minHeight: '45px',
    borderRadius: '30px',
    color: theme.palette.primary.contrastText,
    border: `2px solid ${theme.palette.primary.contrastText}`,
    '& svg': { marginRight: '4px' }
  },
  loginButtonText: {
    fontWeight: 500,
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }
}))
